import React from 'react'


function Local() {
  return (
    <div>Local


       
    </div>
  )
}

export default Local